const PAPER_SIZE_INFINITE = "Infinite";

const paperSize = {
  A3: "A3",
  A4: "A4",
  Letter: "Letter",
  Legal: "Legal"
};

const paperDimensions = {
  A3: {
    paperWidth: 842,
    paperHeight: 1191
  },
  A4: {
    paperWidth: 595,
    paperHeight: 842
  },
  Letter: {
    paperWidth: 612,
    paperHeight: 792
  },
  Legal: {
    paperWidth: 612,
    paperHeight: 1008
  },
  Infinite: {
    paperWidth: 10000,
    paperHeight: 10000
  }
};

const flipDimensions = dim => {
  return {
    paperWidth: dim.paperHeight,
    paperHeight: dim.paperWidth
  };
};

export default {
  PAPER_SIZE_INFINITE,
  paperSize,
  paperDimensions,
  flipDimensions
};
